// //convertPropertyNames - camelCase Content
const pascalCasePattern = new RegExp('^([A-Z])([a-z]+)')
// eslint-disable-next-line no-useless-escape
const lowerCamelPattern = new RegExp('[a-z]+((d)|([A-Z0-9][a-z0-9]+))*([A-Z])?')
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function pascalCaseToCamelCase(propname: any) {
  if (pascalCasePattern.test(propname)) {
    return propname.charAt(0).toLowerCase() + propname.slice(1)
  } else {
    return propname
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const camelCaseToPascalCase = (propname: any): any => {
  if (propname !== undefined) {
    if (lowerCamelPattern.test(propname)) {
      return propname.charAt(0).toUpperCase() + propname.slice(1)
    } else {
      return propname
    }
  }
}
// Other way of doing the above const
// Helper function to convert type names to PascalCase
// const pascalCase = (str: string) => {
//   return str
//     .split("_")
//     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//     .join("");
// };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function convertPropNamesFn(obj: any, converterFn: any): any {
  // Used to convert property names into Pascal Casing
  // If we want other casings, we can cadd a new converterFn, as a prop on the convertPropertyNames function
  let r, value
  const t = Object.prototype.toString.apply(obj)
  if (t == '[object Object]') {
    r = {}
    for (const propname in obj) {
      value = obj[propname]
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      r[converterFn(propname)] = convertPropNamesFn(value, converterFn)
    }
    return r
  } else if (t == '[object Array]') {
    r = []
    for (let i = 0, L = obj.length; i < L; ++i) {
      value = obj[i]
      r[i] = convertPropNamesFn(value, converterFn)
    }
    return r
  }
  return obj
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertPropertyNames = (obj: any, casing?: any): any => {
  // Use casing if we get it, else we use the fallback pascalCaseToCamelCase
  const useCasing = casing !== undefined ? casing : pascalCaseToCamelCase
  return convertPropNamesFn(obj, useCasing)
}

/**
 * Converts the property names of objects in an array from uppercase to lowercase
 * for the first letter while leaving the rest of the letters unchanged.
 *
 * @param array - An array of objects whose property names need to be converted.
 *                If `undefined`, the function will return an empty array.
 * @returns A new array of objects with transformed property names.
 *
 * @template T - The type of the objects in the input array.
 */
type ConvertToLowercase<T> = {
  [K in keyof T as K extends string
    ? `${Lowercase<K extends `${infer F}${infer R}` ? F : ''>}${K extends `${infer F}${infer R}` ? R : ''}`
    : K]: T[K]
}
export function convertPropertiesToLowercase<T>(array: T[] | undefined): ConvertToLowercase<T>[] {
  if (!array) {
    return [] // Return an empty array if the input is undefined
  }
  return array.map((obj) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newObj: any = {}
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const newKey = key.charAt(0).toLowerCase() + key.slice(1)
        newObj[newKey] = obj[key]
      }
    }
    return newObj
  })
}

// Example usage:
// const data: { FirstName: string; LastName: string }[] | undefined = undefined

// const result = convertPropertiesToLowercase(data)

// console.log(result) // Output: []
